/* Presentation-only manual enhancement. Include in the preview theme only.
   No storage, requests, history changes, model changes, or content rewriting. */
(function () {
  'use strict';
  var handles = [
    'instellen-thuisbatterij',
    'instellen-zinvolt-base', 'instellen-zinvolt-power', 'instellen-p1-dongle-pro',
    'handleiding-zinvolt-app', 'installatievragen', 'batterij-uit-en-aanzetten',
    'thuisbatterij-aanmelden', 'uitbreiden-met-extra-stack-module',
    'handleiding-meerdere-systemen', 'instellen-app'
  ];
  var route = location.pathname.replace(/\/+$/, '').match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/([^/]+)$/i);
  if (!route || handles.indexOf(route[1]) === -1) return;
  if (window.ZVGuideConsistency) { window.ZVGuideConsistency.refresh(); return; }
  var controllers = [], scheduled = false;
  function element(tag, name, text) {
    var el = document.createElement(tag);
    if (name) el.className = name;
    if (text) el.textContent = text;
    return el;
  }
  function title(step) {
    var h = step.querySelector('.zv-app-handleiding__chapter-head h2, h2, h3');
    return h ? h.textContent.trim().replace(/\s+/g, ' ') : '';
  }
  function visible(el) {
    return !el.closest('[hidden], [aria-hidden="true"]') && el.getClientRects().length > 0;
  }
  function progress(kind, count) {
    var box = element('div', 'zvgc-progress ' + (kind || ''));
    var number = count ? null : element('strong', 'zvgc-progress__count');
    if (number) box.appendChild(number);
    var name = element('span', 'zvgc-progress__title');
    var track = element('div', 'zvgc-progress__track');
    track.setAttribute('role', 'progressbar');
    track.setAttribute('aria-label', 'Voortgang in deze handleiding');
    track.setAttribute('aria-valuemin', '0');
    var fill = element('span', 'zvgc-progress__fill');
    track.appendChild(fill); box.appendChild(name); box.appendChild(track);
    return { box: box, count: number || count, title: name, track: track, fill: fill };
  }
  function heading(rail) {
    var label = rail.querySelector('.zv-app-handleiding__eyebrow');
    if (!label) {
      label = element('p', 'zv-app-handleiding__eyebrow zv-app-handleiding__toc-label', 'Jouw handleiding');
      rail.prepend(label);
    } else label.textContent = 'Jouw handleiding';
    return label;
  }
  function mobileProgress(scope) {
    var jump = scope.querySelector('.zv-app-handleiding__mobile-jump');
    var p = progress('zvgc-mobile-progress');
    if (jump && !jump.classList.contains('zv-app-handleiding__mobile-jump--bottom')) {
      jump.prepend(p.box);
    } else {
      var content = scope.querySelector('.zv-app-handleiding__content');
      if (!content) return null;
      p.box.classList.add('zvgc-mobile-progress--standalone');
      content.prepend(p.box);
    }
    return p;
  }
  function addController(scope, rail, steps, existingCount, hasMobileRail) {
    if (!rail || !steps.length || rail.hasAttribute('data-zvgc-progress-ready')) return;
    rail.setAttribute('data-zvgc-progress-ready', '');
    var p = progress(existingCount ? 'zvgc-progress--existing' : (hasMobileRail ? '' : 'zvgc-progress--sidebar'), existingCount);
    var label = heading(rail);
    if (existingCount) existingCount.insertAdjacentElement('afterend', p.box);
    else label.insertAdjacentElement('afterend', p.box);
    // Keep the current chapter visible when the existing nav scrolls its rail.
    var progressHeader = element('div', 'zvgc-progress-header');
    label.before(progressHeader);
    progressHeader.appendChild(label);
    if (existingCount) progressHeader.appendChild(existingCount);
    progressHeader.appendChild(p.box);
    var views = [p];
    if (!hasMobileRail) { var mobile = mobileProgress(scope); if (mobile) views.push(mobile); }
    controllers.push({ scope: scope, steps: steps, views: views, current: -1, rail: rail });
    // The existing guide may scroll its rail after selecting a chapter. Keep
    // that chapter below the fixed progress header, without moving the page.
    rail.addEventListener('scroll', schedule, { passive: true });
  }
  function revealCurrentStep(c, current) {
    if (!matchMedia('(min-width: 1000px)').matches || !visible(c.rail)) return;
    var targetId = c.steps[current].id;
    var link = Array.from(c.rail.querySelectorAll('nav a[href]')).find(function (a) { return a.hash === '#' + targetId; });
    if (!link || c.rail.scrollHeight <= c.rail.clientHeight + 1) return;
    var railBox = c.rail.getBoundingClientRect();
    var header = c.rail.querySelector('.zvgc-progress-header');
    var top = Math.max(railBox.top + 12, header ? header.getBoundingClientRect().bottom + 10 : railBox.top + 12);
    var bottom = railBox.bottom - 12;
    if (bottom - top < 36) return;
    var box = link.getBoundingClientRect();
    if (box.top < top - 1) c.rail.scrollTop += box.top - top;
    else if (box.bottom > bottom + 1) c.rail.scrollTop += box.bottom - bottom;
  }
  function restart(root) {
    var stepsHost = root.querySelector('.zv-restart__steps');
    if (!stepsHost || root.querySelector('.zvgc-restart-workspace')) return;
    var steps = Array.from(stepsHost.querySelectorAll('.zv-restart__step'));
    if (!steps.length) return;
    var workspace = element('div', 'zvgc-restart-workspace');
    var rail = element('aside', 'zvgc-rail');
    rail.setAttribute('aria-label', 'Stappenoverzicht');
    rail.appendChild(element('p', 'zvgc-rail__label zv-app-handleiding__eyebrow', 'Jouw handleiding'));
    var nav = element('nav'); nav.setAttribute('aria-label', 'Stappen in deze handleiding');
    var jump = element('label', 'zvgc-rail__jump');
    jump.appendChild(element('span', '', 'Ga naar een stap'));
    var select = element('select');
    steps.forEach(function (step, index) {
      if (!step.id) return;
      var text = (index + 1) + '. ' + title(step);
      var link = element('a', '', text); link.href = '#' + step.id; nav.appendChild(link);
      var option = element('option', '', text); option.value = step.id; select.appendChild(option);
    });
    select.addEventListener('change', function () {
      var target = document.getElementById(select.value);
      if (!target) return;
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      // Give keyboard users the same destination as a normal in-page link.
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
    jump.appendChild(select); rail.appendChild(nav); rail.appendChild(jump);
    stepsHost.before(workspace); workspace.appendChild(rail); workspace.appendChild(stepsHost);
    addController(root, rail, steps, null, true);
  }
  function initialize() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    main.querySelectorAll('.zv-app-handleiding, .zv-guide-workspace').forEach(function (root) {
      if (root.hasAttribute('data-zv-guide-consistency')) return;
      root.setAttribute('data-zv-guide-consistency', '');
      // P1 and the existing wizard already own their progress and navigation.
      if (root.matches('[data-p1-guide], .zv-p1-solo, .zv-guide-workspace') || root.querySelector('[data-p1-progress]')) return;
      if (root.classList.contains('zv-restart')) { restart(root); return; }
      var panels = root.querySelectorAll('[data-zv-model-panel]');
      if (panels.length) {
        panels.forEach(function (panel) {
          addController(panel, panel.querySelector('.zv-app-handleiding__toc'), Array.from(panel.querySelectorAll('.zv-installation__chapter--step')), null, false);
        });
      } else if (root.matches('[data-energy-guide], .zv-energy')) {
        addController(root, root.querySelector('.zv-energy__toc'), Array.from(root.querySelectorAll('[data-energy-step]')), root.querySelector('[data-energy-progress]'), true);
      } else {
        var selector = root.classList.contains('zv-support') ? '[data-zv-support-chapter]' :
          root.classList.contains('zv-installation') ? '.zv-installation__chapter--step' :
          '.zv-app-handleiding__chapter[data-zv-app-section]';
        var steps = Array.from(root.querySelectorAll(selector)).filter(function (step) {
          return /^\d+$/.test(((step.querySelector('.zv-app-handleiding__chapter-number') || {}).textContent || '').trim());
        });
        addController(root, root.querySelector('.zv-app-handleiding__toc'), steps, null, false);
      }
      // Model changes and existing guide visibility controls remain in charge.
      new MutationObserver(schedule).observe(root, { attributes: true, subtree: true, attributeFilter: ['hidden', 'aria-hidden'] });
    });
    schedule();
  }
  function update() {
    scheduled = false;
    var header = document.querySelector('#shopify-section-header, .shopify-section-group-header-group header, sticky-header');
    var threshold = Math.max(110, Math.min(210, header ? header.getBoundingClientRect().bottom + 80 : 145));
    controllers.forEach(function (c) {
      if (!visible(c.scope)) return;
      var shown = c.steps.map(function (step, index) { return { step: step, index: index }; }).filter(function (x) { return visible(x.step); });
      if (!shown.length) return;
      var current = shown[0].index;
      shown.forEach(function (x) { if (x.step.getBoundingClientRect().top <= threshold) current = x.index; });
      var n = current + 1, total = c.steps.length, name = title(c.steps[current]);
      revealCurrentStep(c, current);
      if (c.current === current) return;
      c.current = current;
      c.views.forEach(function (v) {
        v.count.textContent = 'Stap ' + n + ' van ' + total;
        v.title.textContent = name;
        v.track.setAttribute('aria-valuemax', String(total));
        v.track.setAttribute('aria-valuenow', String(n));
        v.track.setAttribute('aria-valuetext', 'Stap ' + n + ' van ' + total + ': ' + name);
        v.fill.style.width = (n / total * 100) + '%';
      });
      if (c.rail.classList.contains('zvgc-rail')) {
        c.rail.querySelectorAll('nav a').forEach(function (a, index) {
          if (index === current) a.setAttribute('aria-current', 'step'); else a.removeAttribute('aria-current');
        });
        var select = c.rail.querySelector('select');
        if (select && document.activeElement !== select) select.value = c.steps[current].id;
      }
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true; requestAnimationFrame(update);
  }
  window.ZVGuideConsistency = { refresh: initialize };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
